import { DEFAULT_INVALID, DEFAULT_REPLACE } from 'cyprus/constants';
import { FORMAT_TYPE } from 'cyprus/enums';
import { FormatValue, FormatValueOptions } from 'cyprus/types';
import { invalidNumber } from 'cyprus/utils';

export const formatDuration = (value: FormatValue, options: FormatValueOptions): string => {
  const { format } = options;
  const ignore = options.ignore || [];
  const duration_seconds = Math.round(Number(value));

  const match = ignore.includes(String(value));

  if (match) {
    return options.replace || DEFAULT_REPLACE;
  }

  if (invalidNumber(value)) {
    return options.invalid || DEFAULT_INVALID;
  }

  const day = Math.floor(duration_seconds / (24 * 60 * 60));
  const hour = Math.floor((duration_seconds - day * 24 * 60 * 60) / 60 / 60);
  const min = Math.floor((duration_seconds - hour * 60 * 60 - day * 24 * 60 * 60) / 60);
  const sec = duration_seconds % 60;

  switch (format) {
    case FORMAT_TYPE.DURATION_SECONDS: {
      if (day) {
        return `${day}d${hour ? ` ${hour}h` : ''}${min ? ` ${min}m` : ''}`;
      }
      if (hour) {
        return `${hour}h${min ? ` ${min}m` : ''}${sec ? ` ${sec}s` : ''}`;
      }
      if (min) {
        return `${min}m${sec ? ` ${sec}s` : ''}`;
      }
      return `${sec}s`;
    }
    case FORMAT_TYPE.DURATION_MINUTES: {
      if (day) {
        return `${day}d${hour ? ` ${hour}h` : ''}${min ? ` ${min}m` : ''}`;
      }
      if (hour) {
        return `${hour}h${min ? ` ${min}m` : ''}`;
      }
      return `${min}m`;
    }
    case FORMAT_TYPE.DURATION_HOURS: {
      return `${String(24 * day + hour).padStart(2, '0')}:${String(min).padStart(2, '0')}`;
    }
    default:
      return String(value || '');
  }
};
